var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 27.1667V3.83333C30 2 28.5 0.5 26.6667 0.5H3.33333C1.5 0.5 0 2 0 3.83333V27.1667C0 29 1.5 30.5 3.33333 30.5H26.6667C28.5 30.5 30 29 30 27.1667ZM9.16667 18L13.3333 23.0167L19.1667 15.5L26.6667 25.5H3.33333L9.16667 18Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.f95d9c45.svg";
export { ForwardRef as ReactComponent };